import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueResource from 'vue-resource'
import VueLocalForage from 'vue-localforage'
import jwt from 'jsonwebtoken'
import 'vue2-toast/lib/toast.css'
import Vue2Filters from 'vue2-filters'
import Toast from 'vue2-toast'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import jquery from 'jquery'
import Geohash from 'latlon-geohash'
import '@/assets/css/main.css'
import VModal from 'vue-js-modal'

window.jquery = jquery
window.$ = jquery

Vue.config.productionTip = false
/* eslint-disable no-new */

let originalVueComponent = Vue.component
Vue.component = function (name, definition) {
  if (name === 'bFormCheckboxGroup' || name === 'bCheckboxGroup' ||
    name === 'bCheckGroup' || name === 'bFormRadioGroup') {
    definition.components = {bFormCheckbox: definition.components[0]}
  }
  originalVueComponent.apply(this, [name, definition])
}
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.use(Toast)
Vue.use(Vue2Filters)
Vue.use(VueLocalForage)
Vue.use(VModal)
Vue.component = originalVueComponent
Vue.http.headers.common['Content-Type'] = 'application/json'

// prod
// Vue.http.options.root = 'https://api.ftth.iliad.fr/app/aboracco/v1'
Vue.http.options.root = 'https://api.ftth.iliad.fr/app/aboracco/v1'
function getPos (callback) {
  if (Object.keys(navigator.geolocation).length !== 0) {
    navigator.geolocation.getCurrentPosition((position) => {
      let geohash = Geohash.encode(position.coords.latitude, position.coords.longitude)
      callback(Geohash.decode(geohash))
    }, (err) => {
      let geohash = null
      switch (err.code) {
        case err.PERMISSION_DENIED:
          geohash = {1: 'User bloque la geolocalisation'}
          break
        case err.POSITION_UNAVAILABLE:
          geohash = {2: 'Localisation introuvable'}
          break
        case err.TIMEOUT:
          geohash = {3: 'Localisation trop long'}
          break
        case err.UNKNOWN_ERROR:
          geohash = {4: 'Erreur interne'}
          break
      }
      callback(geohash)
    }
    )
  } else {
    let geohash = 'Géolocation avec ce navigateur'
    callback(geohash)
  }
}

Vue.http.interceptors.push(function (request, next) {
  if (!navigator.onLine) {
    next(request.respondWith(null, {
      status: 404,
      statusText: ''
    }))
    return
  }

  let _this = this
  getPos(function (geo) {
    request.headers.set('location', JSON.stringify(geo))
    if (localStorage.getItem('token') !== null) {
      let decoded = jwt.decode(localStorage.getItem('token'))
      let unix = Math.round(+new Date() / 1000)

      if (decoded.exp <= unix) {
        _this.$router.push('/')
        _this.$toast.bottom('Votre session a expiré')
      } else {
        request.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
        next()
      }
    } else {
      next()
    }
  })
})

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js